<template>
    <div>
        <select class="form-control" name="budget_id" id="budget_id" @change="onChange($event)">
            <option value=''></option>
            <option v-for="budget in options" :key="budget.id" :value="budget.id" :selected="selectedValue == budget.id">{{ budget.name }}</option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'BudgetSelector',
    props: [
        'selectedValue',
    ],
    data() {
        return {
            value: '',
            options: [
                { id: '1', name: 'La sesión debe ser de tipo presupuesto' },
                { id: '2', name: 'La sesión NO debe ser de tipo presupuesto' },
            ]
        };
    },
    methods: {
        onChange(event) {
            const selectedOption = event.target.value;
            this.value = selectedOption;
            this.$emit('update', selectedOption);
        }
    }
};
</script>

<style>
.form-control {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    height: fit-content;
}
</style>
